export default __webpack_public_path__ + "static/media/ic_visibility_off.73f484a7.svg";